import { render } from "src/website-apps/shared/utils/render";
import { VenueRoot } from "./root";

render(<VenueRoot />);
